import { FC, useState, useEffect } from 'react';
import { Anchor } from 'antd-v5';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

interface IProps {
    mobile?: boolean;
}

const Scollbar: FC<IProps> = ({ mobile }) => {
    const { t } = useLang('xcode');
    const [showPcNav, setShowPcNav] = useState(true);
    const list = [
        {
            key: 'Performance',
            href: '#Performance',
            title: t('nav1'),
        },
        {
            key: 'x-fusion-second',
            href: '#x-fusion-second',
            title: t('nav2'),
        },
        {
            key: 'x-fusion-fourth',
            href: '#x-fusion-fourth',
            title: t('nav3'),
        },
        {
            key: 'Products',
            href: '#Products',
            title: t('nav4'),
        },
    ];

    const handleClick = (_e: any, target: any) => {
        document.querySelector(target.href)?.scrollIntoView({
            behavior: 'smooth',
        });
    };

    let interObserver: IntersectionObserver | null;
    useEffect(() => {
        const apperCb: IntersectionObserverCallback = (params: IntersectionObserverEntry[]) => {
            const data = params[0];
            const calIconStatus = data.intersectionRatio <= 0;
            setShowPcNav(calIconStatus);
        };
        interObserver && interObserver.disconnect();
        interObserver = new IntersectionObserver(apperCb);

        const chooseBtn = document.querySelector('.footer-b');
        if (chooseBtn) {
            interObserver.observe(chooseBtn as HTMLElement);
        }

        return () => {
            interObserver && interObserver.disconnect();
        };
    }, []);

    return (
        <div className={styled.Scollbar}>
            <div className={mobile ? 'mobile' : `pc ${showPcNav ? '' : 'hidden'}`}>
                <Anchor items={list} direction={mobile ? 'horizontal' : 'vertical'} offsetTop={mobile ? 0 : 30} onClick={handleClick} />
            </div>
        </div>
    );
};

export default Scollbar;
